// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CardComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";
import * as DriverRecordProfileVMMapper from "./DriverRecordProfileVMMapper.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

function getView(driverInfo) {
  return React.createElement(CardComponent$Catalyst.make, {
              title: "Driver Info",
              className: "driver-info-container",
              children: React.createElement(FetchLoadableViewMapper$Catalyst.make, {
                    loadableData: driverInfo,
                    children: (function (driverInfo) {
                        return CardRowViewMapper$Catalyst.CardRecordView.make("record", DriverRecordProfileVMMapper.getVM(driverInfo.driverProfile));
                      })
                  })
            });
}

export {
  getView ,
  
}
/* react Not a pure module */
